import React from "react";
import CanvasJSReact from "../canvasjs.react";
import axios from "axios";

//var CanvasJSReact = require('./canvasjs.react');

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

class SpeakerView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vibe: 98.41,
      meetingId: ""
    };
    this.recentVibes = [98.41, 98.41, 98.41, 98.41, 98.41, 98.41, 98.41, 98.41, 98.41, 98.41]
  }

  componentDidMount() {
    const checkInterval = 3 * 1000;
    const checkTheVibe = () => {
      let theVibe = `http://144.126.212.184:8000/getVibe/${this.state.meetingId}`;
      let messagePromise = axios.get(theVibe);
      messagePromise.then(
        (res) => {
          console.log(res);
          this.recentVibes.shift();
          this.recentVibes.push(res.data);
          this.setState({ vibe: res.data });
          console.log("vibe in state", this.state.vibe);
        },
        (error) => {
          console.log("got error");
          console.log(error);
        }
      );
    };

    let getMeetingIDPromise = axios.get("http://144.126.212.184:8000/getNewMeeting");
    getMeetingIDPromise.then(
      (res) => {
        this.setState({
          meetingId: res.data,
        });
        this.timerID = setInterval(checkTheVibe, checkInterval);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  render() {
    function getColor(value) {
      //value from 0 to 1
      var hue = (value * 120).toString(10);
      return ["hsl(", hue, ",100%,50%)"].join("");
    }

    const options = {
      animationEnabled: true,
      title: {
        text: "Your Group's Last 30 Seconds' Vibe ",
      },
      axisY: {
        title: "VibeScore",
        suffix: "",
      },
      data: [
        {
          type: "splineArea",
          xValueFormatString: "MM",
          yValueFormatString: "#,##0.## bn kW⋅h",
          dataPoints: [
            { x: -30, y: this.recentVibes[0] },
            { x: -27, y: this.recentVibes[1] },
            { x: -24, y: this.recentVibes[2] },
            { x: -21, y: this.recentVibes[3] },
            { x: -18, y: this.recentVibes[4] },
            { x: -15, y: this.recentVibes[5] },
            { x: -12, y: this.recentVibes[6] },
            { x: -9, y: this.recentVibes[7] },
            { x: -6, y: this.recentVibes[8] },
            { x: -3, y: this.recentVibes[9] },
          ],
        },
      ],
    };
    return (
      <div>
        {this.state.meetingId === "" ? (
          <h3>Give us a moment, we are getting a meeting ID for you</h3>
        ) : (
          <div>
            <h3>
              Your meeting ID is <i>{this.state.meetingId}</i>
            </h3>
            <p>
              Share the meeting ID with your attendees so that they can join the
              right meeting
            </p>
          </div>
        )}
        <div
          style={{
            display: "flex",
            backgroundColor: getColor(this.state.vibe / 100),
            transition: "all .5s ease",
            WebkitTransition: "all .5s ease",
            MozTransition: "all .5s ease",
          }}
        >
          <p>
            You’re all set! We will keep you updated on the vibe of the meeting.
            The vibe score is {this.state.vibe}.
          </p>
          <CanvasJSChart options={options} />
        </div>
      </div>
    );
  }
}

export default SpeakerView;
